module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/grid/flex-column-reverse-and-wrap/flex-column-reverse-and-wrap.component.scss
// module id = ./src/app/features/grid/flex-column-reverse-and-wrap/flex-column-reverse-and-wrap.component.scss
// module chunks = main